export default __webpack_public_path__ + "static/media/sale1.73ed04b4.png";